const alarmDefs = {
    "WarningOrFault01": {
        "0": {
            "ID": "1",
            "Name": "System Fault status"
        },
        "1": {
            "ID": "2",
            "Name": "System Alarm status"
        },
        "2": {
            "ID": "3",
            "Name": "System Derating status"
        },
        "3": {
            "ID": "4",
            "Name": "System Booting status"
        },
        "4": {
            "ID": "5",
            "Name": "System Grid-tied status"
        },
        "5": {
            "ID": "6",
            "Name": "System Off-grid status"
        },
        "9": {
            "ID": "7",
            "Name": "System Failed status"
        }
    },
    "WarningOrFault02": {
        "0": {
            "ID": "8",
            "Name": "System ON/OFF status"
        },
        "1": {
            "ID": "9",
            "Name": "System Standby status"
        },
        "2": {
            "ID": "10",
            "Name": "System Charging status"
        },
        "3": {
            "ID": "11",
            "Name": "System Discharging status"
        },
        "4": {
            "ID": "12",
            "Name": "System Fully charged status"
        },
        "5": {
            "ID": "13",
            "Name": "System Totally discharged status"
        },
        "6": {
            "ID": "14",
            "Name": "System Constant Volt topping charging"
        }
    },
    "WarningOrFault03": {
        "3": {
            "ID": "15",
            "Name": "Drooping status"
        }
    },
    "WarningOrFault04": {
        "0": {
            "ID": "16",
            "Name": "Grid reconnection accessing"
        },
        "1": {
            "ID": "17",
            "Name": "Grid recovery delaying"
        },
        "5": {
            "ID": "18",
            "Name": "Electrical room fan stop"
        }
    },
    "WarningOrFault05": {
        "0": {
            "ID": "19",
            "Name": "AC module 01 online status"
        }
    },
    "WarningOrFault06": {
        "0": {
            "ID": "20",
            "Name": "EPO"
        },
        "1": {
            "ID": "21",
            "Name": "Calibration parameter abnormal"
        },
        "10": {
            "ID": "30",
            "Name": "Master Conflict Fault"
        },
        "11": {
            "ID": "31",
            "Name": "DSP Parameter mismatch"
        },
        "12": {
            "ID": "32",
            "Name": "Monitor Parameter mismatch"
        },
        "13": {
            "ID": "33",
            "Name": "Drm0 Shutdown"
        },
        "14": {
            "ID": "34",
            "Name": "Module quantity abnormal"
        },
        "2": {
            "ID": "22",
            "Name": "Sampling zero abnormal"
        },
        "3": {
            "ID": "23",
            "Name": "Flash abnormal"
        },
        "4": {
            "ID": "24",
            "Name": "DSP initializing abnormal"
        },
        "5": {
            "ID": "25",
            "Name": "Monitor initializing abnormal"
        },
        "6": {
            "ID": "26",
            "Name": "DSP version abnormal"
        },
        "7": {
            "ID": "27",
            "Name": "CPLD version abnormal"
        },
        "8": {
            "ID": "28",
            "Name": "Hardware version abnormal"
        },
        "9": {
            "ID": "29",
            "Name": "ID reduplicated fault"
        }
    },
    "WarningOrFault07": {
        "1": {
            "ID": "35",
            "Name": "CAN A comm. Fault"
        },
        "11": {
            "ID": "43",
            "Name": "Grid ammeter comm. timeout"
        },
        "2": {
            "ID": "36",
            "Name": "CAN B comm. fault"
        },
        "3": {
            "ID": "37",
            "Name": "CAN C comm. fault"
        },
        "4": {
            "ID": "38",
            "Name": "Synchronous signal 1 fault"
        },
        "6": {
            "ID": "39",
            "Name": "Auxiliary board comm. fault"
        },
        "7": {
            "ID": "40",
            "Name": "SPI comm. fault"
        },
        "8": {
            "ID": "41",
            "Name": "EMS comm. connection timeout"
        },
        "9": {
            "ID": "42",
            "Name": "BMS comm. connection timeout"
        }
    },
    "WarningOrFault08": {
        "1": {
            "ID": "44",
            "Name": "Module Fan fault 1"
        },
        "11": {
            "ID": "45",
            "Name": "Auxiliary power fault 1"
        },
        "12": {
            "ID": "46",
            "Name": "Auxiliary power fault 2"
        },
        "13": {
            "ID": "47",
            "Name": "Auxiliary power fault 3"
        }
    },
    "WarningOrFault09": {
        "1": {
            "ID": "48",
            "Name": "Module over temperature 1"
        },
        "11": {
            "ID": "51",
            "Name": "Module overtemp. derating"
        },
        "13": {
            "ID": "52",
            "Name": "Ambient overtemp. derating"
        },
        "2": {
            "ID": "49",
            "Name": "Module over temperature 2"
        },
        "9": {
            "ID": "50",
            "Name": "Ambient overtemp. fault"
        }
    },
    "WarningOrFault10": {
        "10": {
            "ID": "53",
            "Name": "Controller sampling difference"
        },
        "11": {
            "ID": "54",
            "Name": "Battery under energy"
        },
        "12": {
            "ID": "55",
            "Name": "Insulation detect 1 abnormal"
        },
        "13": {
            "ID": "56",
            "Name": "Insulation detect 2 abnormal"
        }
    },
    "WarningOrFault11": {
        "10": {
            "ID": "58",
            "Name": "Module current limit alarm 2"
        },
        "11": {
            "ID": "59",
            "Name": "Module current limit alarm 3"
        },
        "12": {
            "ID": "60",
            "Name": "Module current limit alarm 4"
        },
        "13": {
            "ID": "61",
            "Name": "Module current limit alarm 5"
        },
        "14": {
            "ID": "62",
            "Name": "Module current limit alarm 6"
        },
        "15": {
            "ID": "63",
            "Name": "Module current limit alarm 7"
        },
        "9": {
            "ID": "57",
            "Name": "Module current limit alarm 1"
        }
    },
    "WarningOrFault12": {
        "1": {
            "ID": "64",
            "Name": "Module current abnormal 1"
        },
        "2": {
            "ID": "65",
            "Name": "Module current abnormal 2"
        },
        "3": {
            "ID": "66",
            "Name": "Module current abnormal 3"
        },
        "4": {
            "ID": "67",
            "Name": "Module current abnormal 4"
        },
        "5": {
            "ID": "68",
            "Name": "Module current abnormal 5"
        },
        "6": {
            "ID": "69",
            "Name": "Module current abnormal 6"
        },
        "7": {
            "ID": "70",
            "Name": "Module current abnormal 7"
        }
    },
    "WarningOrFault13": {
        "0": {
            "ID": "71",
            "Name": "DC input over voltage"
        },
        "1": {
            "ID": "72",
            "Name": "DC input under voltage"
        },
        "3": {
            "ID": "73",
            "Name": "DC overload alarm"
        },
        "4": {
            "ID": "74",
            "Name": "DC overload timeout"
        },
        "5": {
            "ID": "75",
            "Name": "DC input soft start failed"
        },
        "6": {
            "ID": "76",
            "Name": "DC input galvanic-break-device open circuit"
        },
        "7": {
            "ID": "77",
            "Name": "DC input galvanic-break-device short circuit"
        },
        "9": {
            "ID": "78",
            "Name": "DC input soft galvanic-break-device fault"
        }
    },
    "WarningOrFault14": {
        "0": {
            "ID": "79",
            "Name": "DC bus over voltage"
        },
        "1": {
            "ID": "80",
            "Name": "DC bus under voltage"
        },
        "2": {
            "ID": "81",
            "Name": "DC bus voltage unbalanced"
        },
        "3": {
            "ID": "82",
            "Name": "DC bus soft start failed"
        },
        "9": {
            "ID": "83",
            "Name": "BMS shutdown fault"
        }
    },
    "WarningOrFault15": {
        "0": {
            "ID": "84",
            "Name": "AC bus over voltage"
        },
        "1": {
            "ID": "85",
            "Name": "AC bus under voltage"
        },
        "11": {
            "ID": "93",
            "Name": "Ac overload alarm"
        },
        "12": {
            "ID": "94",
            "Name": "Ac overload timeout"
        },
        "13": {
            "ID": "95",
            "Name": "Ac bus connection forbidden"
        },
        "14": {
            "ID": "96",
            "Name": "Ac bus neural lost"
        },
        "2": {
            "ID": "86",
            "Name": "AC bus over frequency"
        },
        "3": {
            "ID": "87",
            "Name": "AC bus under frequency"
        },
        "4": {
            "ID": "88",
            "Name": "AC bus phase reversed"
        },
        "5": {
            "ID": "89",
            "Name": "AC bus voltage asymmetric"
        },
        "6": {
            "ID": "90",
            "Name": "AC bus voltage abnormal"
        },
        "7": {
            "ID": "91",
            "Name": "AC bus phase lost"
        },
        "8": {
            "ID": "92",
            "Name": "Islanding protection"
        }
    },
    "WarningOrFault16": {
        "1": {
            "ID": "97",
            "Name": "Off-grid Volt oscillation"
        },
        "6": {
            "ID": "98",
            "Name": "On/Off-grid toggling error"
        },
        "7": {
            "ID": "99",
            "Name": "AC soft start failed"
        },
        "8": {
            "ID": "100",
            "Name": "AC galvanic-break-device open circuit"
        },
        "9": {
            "ID": "101",
            "Name": "AC galvanic-break-device short circuit"
        }
    }
}



function parseAlarmData(data) {
    const InverterAlarms = [];
    const BatteryAlarms = []
    for (let i = 1; i < 12; i++) {
        const fn = "WarningOrFault" + i.toString().padStart(2, '0')
        const defs = alarmDefs[fn];
        if (!defs) {
            continue;
        }
        const c = data[fn];
        if (!c) {
            continue;
        }

        for (let j = 0; j < 16; j++) {
            const bit = (c >> j) & 1;
            const def = defs[j];
            if (bit === 1 && def) {
                InverterAlarms.push({"Code": def["ID"], "Name": def["Name"]});
                if (def["ID"] == 42 || def["ID"] == 54 || (def["ID"] >= 71 && def["ID"] <= 83)) {
                    BatteryAlarms.push({"Code": def["ID"], "Name": def["Name"]});
                }
            }
        }
    }

    return {InverterAlarms, BatteryAlarms};
}

export default {
    parseAlarmData,
}